import { Suspense } from 'react';
import type { CommonProps } from '@/@types/common';
import { LAYOUT_COLLAPSIBLE_SIDE } from '@/constants/theme.constant';
import Loading from '@/components/shared/Loading';
import { useAuth } from '@/auth';
import PostLoginLayout from './PostLoginLayout';
import PreLoginLayout from './PreLoginLayout';

const Layout = ({ children }: CommonProps) => {
  const layoutType = LAYOUT_COLLAPSIBLE_SIDE;

  const { authenticated } = useAuth();

  return (
    <Suspense
      fallback={
        <div className="flex h-[100vh] flex-auto flex-col">
          <Loading loading={true} />
        </div>
      }
    >
      {authenticated ? (
        <PostLoginLayout layoutType={layoutType}>{children}</PostLoginLayout>
      ) : (
        <PreLoginLayout>{children}</PreLoginLayout>
      )}
    </Suspense>
  );
};

export default Layout;
